"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const flatten_1 = tslib_1.__importDefault(require("lodash/flatten"));
const isEmptyObject_1 = tslib_1.__importDefault(require("../helpers/isEmptyObject"));
const setVersionIdsOfContentStates_1 = tslib_1.__importDefault(require("../helpers/versions/setVersionIdsOfContentStates"));
const zeroStates_1 = require("../zeroStates");
const areDocsEqual_1 = tslib_1.__importDefault(require("./areDocsEqual"));
const getKeyFromState_1 = require("./getKeyFromState");
function getDummyNonExistingStates(states, contents, user) {
    return flatten_1.default(contents.map((content) => zeroStates_1.nonExistingNonRootZeroStates(content, user, states)));
}
exports.getDummyNonExistingStates = getDummyNonExistingStates;
function getDummyNonExistingStatesWithVersions(command, states, contents, user) {
    return flatten_1.default(contents.map((content) => {
        if (content && !isEmptyObject_1.default(content)) {
            const nonExistingStates = zeroStates_1.nonExistingNonRootZeroStates(content, user, states);
            setVersionIdsOfContentStates_1.default(command, user, content, nonExistingStates);
            return nonExistingStates;
        }
        return [];
    }));
}
exports.getDummyNonExistingStatesWithVersions = getDummyNonExistingStatesWithVersions;
function isRootState(state) {
    return `${state.contentId}_${state.contentId}` === state.rootContentId_contentId;
}
function filterNonUpdatedDummyStates(allStates, nonRootZeroStatesToRemove) {
    const nonRootZeroStatesDic = {};
    nonRootZeroStatesToRemove.forEach((state) => (nonRootZeroStatesDic[getKeyFromState_1.getKeyFromState(state)] = state));
    const isNonUpdatedNonRootDummyState = (state) => {
        if (!isRootState(state)) {
            const dummyDoc = nonRootZeroStatesDic[getKeyFromState_1.getKeyFromState(state)];
            if (dummyDoc && areDocsEqual_1.default(dummyDoc, state)) {
                return false;
            }
            return true;
        }
        return true;
    };
    return allStates.filter(isNonUpdatedNonRootDummyState);
}
exports.filterNonUpdatedDummyStates = filterNonUpdatedDummyStates;
//# sourceMappingURL=addRemoveNonUpdatedStates.js.map